export var VisitorType;
(function (VisitorType) {
    VisitorType[VisitorType["VISITOR"] = 0] = "VISITOR";
    VisitorType[VisitorType["MEMBER"] = 1] = "MEMBER";
    VisitorType[VisitorType["VISITOR_OR_MEMBER"] = 2] = "VISITOR_OR_MEMBER";
})(VisitorType || (VisitorType = {}));
